export default {
  availableItems(state) {
    return state.items.filter(item => item.reason_code !== "disabled");
  }
};
